import React, { useEffect, useRef } from "react";
import {
  FaUniversity,
  FaHospital,
  FaBus,
  FaPlane,
  FaShoppingBag,
  FaTrain, FaVrCardboard  
} from "react-icons/fa";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import locationMap from "../Assets/maps/location-4.webp";
import map from "../Assets/maps/amayra-tullium-map.webp";
import floor1 from "../Assets/maps/map-new-3.jpg";
import floor2 from "../Assets/maps/map-new-2.jpg";
import floor3 from "../Assets/maps/map-new-1.jpg";
import floor4 from "../Assets/maps/map-new-4.jpg";
import backgroundAm3 from "../Assets/Media/Amayra-text-bg.jpg";
import amyraBanner from "../Assets/about/amyra-trilum-baner.webp";
import gallery1 from "../Assets/maps/img-1.webp";
import gallery2 from "../Assets/maps/img-2.webp";
import gallery3 from "../Assets/maps/img-3.webp";
import gallery4 from "../Assets/maps/img-4.webp";
import gallery5 from "../Assets/maps/img-5.webp";
import gallery6 from "../Assets/maps/img-6.webp";
import gallery7 from "../Assets/maps/img-7.webp";
import gallery8 from "../Assets/maps/img-8.webp";
import gallery9 from "../Assets/maps/img-9.webp";
import club from "../Assets/maps/house-club-image.webp";
import bgTop from "../Assets/maps/bg-shadow-img.webp";
import { MdOutlineFileDownload } from "react-icons/md";

gsap.registerPlugin(ScrollTrigger);

const locations = [
  {
    title: "Rayat Bahara University ",
    time: "- 8 Mins",
    icon: <FaUniversity className="text-black-800 text-[33px]" />,
  },
  {
    title: "Hospital",
    time: " - 7 Mins",
    icon: <FaHospital className="text-black-800 text-[33px]" />,
  },
  {
    title: "Kharar Bus Stand",
    time: " - 3 Mins",
    icon: <FaBus className="text-black-800 text-[33px]" />,
  },
  {
    title: "International Airport",
    time: " - 25 Mins",
    icon: <FaPlane className="text-black-800 text-[33px]" />,
  },
  {
    title: "VR Punjab Mall",
    time: "  - 10 Mins",
    icon: <FaShoppingBag className="text-black-800 text-[33px]" />,
  },
  {
    title: "Mohali Railway Station",
    time: " - 20 Mins",
    icon: <FaTrain className="text-black-800 text-[33px]" />,
  },
];

const floors = [
  {
    title: " Typical Floor Plan",
    subTitle: " Tower A (3BHK)",
    image: floor1,
    superArea: "1851 SQ. FT.",
    coveredArea: "1523 SQ. FT.",
    carpetArea: "1124 SQ. FT.",
  },
  {
    title: " Typical Floor Plan",
    subTitle: " Tower B (3BHK)",
    image: floor2,
    superArea: "1767 SQ. FT.",
    coveredArea: "1515 SQ. FT.",
    carpetArea: "1124 SQ. FT.",
  },
  {
    title: " Typical Floor Plan",
    subTitle: " Tower C (3BHK)",
    image: floor3,
    superArea: " 1851 SQ. FT.",
    coveredArea: "1523 SQ. FT.",
    carpetArea: "1124 SQ. FT.",
  },
  {
    title: " Typical Floor Plan",
    subTitle: " Tower D (3BHK)",
    image: floor4,
    superArea: "2704 SQ. FT.",
    coveredArea: "2127.50 SQ. FT.",
    carpetArea: "1506 SQ. FT.",
  },
];

const amenitiesList = [
  { number: "01", label: "Commercial Entry" },
  { number: "02", label: "Commercial Exit" },
  { number: "03", label: "Housing Entry/Exit" },
  { number: "04", label: "Waterbody" },
  { number: "05", label: "4-Wheeler Parking" },
  { number: "06", label: "Ramp to Basement" },
  { number: "07", label: "Seats" },
  { number: "08", label: "Lawn" },
  { number: "09", label: "Kid's Play Area" },
  { number: "10", label: "Club" },
  { number: "11", label: "Skating Rink" },
  { number: "12", label: "Outdoor Fitness" },
  { number: "13", label: "Cricket Pitch" },
  { number: "14", label: "Yoga Lawn" },
  { number: "15", label: "Reflexogy Park" },
  { number: "16", label: "Fire Pit" },
  { number: "17", label: "Badminton Court" },
  { number: "18", label: "Guard's Room" },
  { number: "19", label: "Stairs" },
  { number: "20", label: "Parking Cum Plaza" },
  { number: "21", label: "Entry to Plaza" },
  { number: "22", label: "Corridor" },
  { number: "23", label: "Basketball Practice Court" },
];

const highlightsLeft = [
  "Gated & Secured Campus",
  "High End Club",
  "24/7 CCTV Security",
  "Rain Water Harvesting",
  "Earthquake Resistant Structure",
  "Mivan Construction",
  "Power Back-up & Water Supply",
];

const highlightsRight = [
  "Basement & Open Car Parking",
  "Kids Play Area",
  "Yoga Meditation Area",
  "Badminton / Tennis Court",
  "Commercial Shops at Front",
  "Well Connected to Highway",
];

const SitePlans = () => {
  const heroRef = useRef(null);
  const visionImageRef = useRef(null);
  const sitePlanTitleRef = useRef(null);
  const locationCardsRef = useRef([]);
  const mapSectionTitleRef = useRef(null);
  const mapSectionTextRef = useRef(null);
  const amenitiesTitleRef = useRef(null);
  const amenitiesListRef = useRef([]);
  const sitePlanImageRef = useRef(null);
  const containerRef = useRef(null);
  const galleryRef = useRef(null);
  const addToLocationCardsRef = (el) => {
    if (el && !locationCardsRef.current.includes(el)) {
      locationCardsRef.current.push(el);
    }
  };
  const addToAmenitiesListRef = (el) => {
    if (el && !amenitiesListRef.current.includes(el)) {
      amenitiesListRef.current.push(el);
    }
  };
  useEffect(() => {
    gsap.from(heroRef.current, {
      opacity: 0,
      y: 100,
      duration: 1,
      scrollTrigger: {
        trigger: heroRef.current,
        start: "top bottom",
        toggleActions: "play none none none",
      },
    });

    gsap.from(visionImageRef.current, {
      opacity: 0,
      scale: 1.2,
      duration: 1.2,
      scrollTrigger: {
        trigger: visionImageRef.current,
        start: "top 75%",
      },
    });

    gsap.from(sitePlanTitleRef.current, {
      opacity: 0,
      x: -50,
      duration: 0.8,
      scrollTrigger: {
        trigger: sitePlanTitleRef.current,
        start: "top 75%",
      },
    });

    locationCardsRef.current.forEach((card, index) => {
      gsap.from(card, {
        opacity: 0,
        y: 30,
        duration: 0.6,
        delay: index * 0.1,
        scrollTrigger: {
          trigger: card,
          start: "top 80%",
        },
      });
    });

    gsap.from(mapSectionTitleRef.current, {
      opacity: 0,
      y: 50,
      duration: 0.8,
      scrollTrigger: {
        trigger: mapSectionTitleRef.current,
        start: "top 75%",
      },
    });

    gsap.from(mapSectionTextRef.current, {
      opacity: 0,
      x: 50,
      duration: 0.8,
      scrollTrigger: {
        trigger: mapSectionTextRef.current,
        start: "top 75%",
      },
    });

    gsap.from(amenitiesTitleRef.current, {
      opacity: 0,
      y: 30,
      duration: 0.8,
      scrollTrigger: {
        trigger: amenitiesTitleRef.current,
        start: "top 75%",
      },
    });

    amenitiesListRef.current.forEach((item, index) => {
      gsap.from(item, {
        opacity: 0,
        x: index % 2 === 0 ? -20 : 20,
        duration: 0.5,
        delay: index * 0.05,
        scrollTrigger: {
          trigger: item,
          start: "top 85%",
        },
      });
    });

    gsap.from(sitePlanImageRef.current, {
      opacity: 0,
      scale: 0.95,
      duration: 1.2,
      scrollTrigger: {
        trigger: sitePlanImageRef.current,
        start: "top 65%",
      },
    });
    gsap.from(galleryRef.current, {
      opacity: 0.5,
      y: 50,
      duration: 1,
      scrollTrigger: {
        trigger: galleryRef.current,
        start: "top 75%",
      },
    });

    gsap.to(".floating-element", {
      y: 20,
      duration: 4,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
    });

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  useEffect(() => {
    const sections = gsap.utils.toArray(".floor-section");

    sections.forEach((section, index) => {
      if (index < sections.length - 0) {
        ScrollTrigger.create({
          trigger: section,
          start: "top top",
          end: "bottom top",
          pin: true,
          pinSpacing: false,
          markers: false, // Set to true for debugging
        });
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Banner */}
      <section
        ref={heroRef}
        className="mt-[-107px] relative h-[100vh] flex items-end justify-start"
        style={{
          backgroundImage: `url('${amyraBanner}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          overflow: "hidden",
        }}
      >
        <div className="w-full z-10 md:px-4 px-2 pb-[40px] flex justify-between items-end">
          <div className="floating-element mx-auto bg-opacity-20  w-full flex md:flex-row flex-col items-center justify-between">
            {/* Heading */}
            <h1
              className="md:text-7xl text-5xl font-bold text-white mb-8"
              style={{ textShadow: "2px 2px 4px rgba(0,0,0,0.8)" }}
            >
              Amayra Trillium
            </h1>
            {/* Image above heading */}
            <div>
              <a
                href="https://digitour.housing.com/projects/Amayra_Trillium/3_Bhk"
                target="_blank"
                className="bg-white w-[250px] text-[16px] text-[#521a27]-700 font-semibold px-3 py-2 shadow-lg hover:bg-gray-200 transition mb-4 flex items-center justify-center gap-1"
              >
                <b className="flex items-center gap-2"><FaVrCardboard /> Virtual Tour</b>
              </a>

            </div>
            <div>
              <a
                href="/"
                className="bg-white text-[14px] text-[#521a27]-700 font-semibold px-3 py-2 shadow-lg hover:bg-gray-200 transition mb-4 flex items-center justify-center gap-1"
              >
                <b>PBRERA-SAS80-PR1207</b> 
              </a>

              <a
                href="/MAIN_BROCHURE.pdf"
            
                className="bg-white text-[22px] text-black-700 font-semibold px-6 py-2 shadow-lg hover:bg-gray-200 transition mb-4 flex items-center gap-1"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download Brochure <MdOutlineFileDownload className="text-2xl" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* map section */}
      <div className="bg-white md:p-10 p-5 gap-4">
        <div className="flex flex-col gap-4">
          {/* Left - Location Cards */}
          <div className="w-full flex flex-col gap-1 items-top">
            <div className="lg:flex lg:flex-row flex-col justify-between items-center">
              <h2
                ref={mapSectionTitleRef}
                className="h2 2xl:text-[55px] xl:text-[48px] lg:text-[46px] md:text-[40px] text-[30px] font-bold mb-[10px] leading-[120%] capitalize"
              >
                A Home Of Comfort
              </h2>
              <p
                ref={mapSectionTextRef}
                className="max-w-3xl w-[80%] pb-[20px] font-normal text-black  text-[16px] "
              >
                Step inside a space where comfort meets elegance, and every
                detail speaks of refined living. Thoughtfully designed interiors
                offer a seamless blend of style and functionality — from airy
                living rooms that invite natural light to serene bedrooms
                crafted for restful nights. High-quality finishes, intelligent
                layouts, and timeless aesthetics come together to create a home
                that feels both luxurious and deeply personal.
              </p>
            </div>
            <div className="w-[100%] text-center h-[0.5px] bg-[#ccc] mx-auto mb-2"></div>
          </div>

          {/* Right - Map Image */}
          <div className="w-full grid lg:grid-cols-1 gap-2 justify-center text-center items-top">
            <h2 className="h2 capitalize 2xl:text-[55px] xl:text-[48px] lg:text-[46px] md:text-[40px] text-[30px] text-center font-semibold leading-snug mb-[20px] mx-auto">
              Site Plan
            </h2>
            <img
              ref={sitePlanImageRef}
              src={map}
              loading="lazy"
              decoding="async"
              alt="Location Map"
              className="mx-auto"
            />
            <div>
              <h5
                ref={amenitiesTitleRef}
                className="capitalize text-left md:text-[45px] text-[30px] mb-2 font-bold"
              >
                Amenities Map Key
              </h5>
              <div className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 mx-auto">
                {amenitiesList.map((item, idx) => (
                  <div
                    key={idx}
                    ref={addToAmenitiesListRef}
                    className="group relative pl-0 py-[10px] overflow-hidden rounded-[20px] cursor-pointer"
                  >
                    {/* Water drop overlay */}

                    <div className="absolute inset-0 bg-[#521a27] scale-0 group-hover:scale-100 transition-transform duration-500 ease-out rounded-[20px] origin-center z-0"></div>
                    <div className="relative z-10 flex items-center justify-start gap-1 mb-0 lg:leading-[40px] leading-[120%] px-4">
                      <p className="capitalize text-black-500 md:text-[16px] text-[14px] font-semibold flex flex-1 items-center  lg:text-center text-start  transition-colors duration-300 group-hover:text-white my-1">
                        <b className="text-black-700 lg:text-[45px] text-[25px] pr-[10px] group-hover:text-white">
                          <i>{item.number}</i>
                        </b>{" "}
                        {item.label}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* floor section - No animations */}
      <div
        className="min-h-screen "
        style={{
          backgroundImage: `url('${bgTop}')`,
          backgroundPosition: "center",
          backgroundSize: "contain",
          backgroundRepeat: "repeat-x",
        }}
      >
        <div className="w-full lg:px-4 px-2 p-[20px] lg:p-[40px]">
          <div className="w-full flex mb-7 justify-between items-center lg:flex-row flex-col">
            <div className="flex flex-col">
              <p className="lg:text-3xl text-lg text-black font-semibold">
                FLOOR PLANS
              </p>
              <h2 className="h2 capitalize 2xl:text-[55px] xl:text-[48px] lg:text-[46px] md:text-[40px] text-[30px] mb-4 leading-[120%] font-[700] ">
                The Proof Is In <br className="hidden lg:block" /> Our Portfolio
              </h2>
            </div>
            <p className="lg:w-1/2 w-full text-gray font-normal  text-[16px]">
              We make even the wildest architectural dreams into dramatic yet
              feasible finished products anyone would be proud of. Our designs
              merge creativity with precision, ensuring beauty never compromises
              functionality. From concept to completion, we craft spaces that
              inspire, endure, and tell your unique story.
            </p>
          </div>
          <div ref={containerRef} className="space-y-6 md:space-y-10">
            {floors.map((floor, index) => (
              <div
                key={index}
                className="floor-section w-full bg-white overflow-hidden flex flex-col md:flex-row relative z-40"
              >
                <div className="md:w-[70%] w-[100%] lg:h-[100vh] h-[50vh] p-4 flex items-center justify-center relative z-40">
                  <div className="relative">
                    <img
                      src={floor.image}
                      loading="lazy"
                      decoding="async"
                      alt="Family dining together"
                      className="w-[95%] h-auto object-contain"
                    />
                  </div>
                </div>
                <div className="md:w-[30%] w-[100%] lg:p-4 p-3 flex flex-col justify-center">
                  <h3 className="capitalize text-[18px] lg:text-[25px] font-bold text-black-800 mb-0">
                    {floor.title}
                  </h3>
                  <h4 className="text-[33px] lg:text-[40px] font-semibold">
                    {floor.subTitle}
                  </h4>
                  <div className="inline-block bg-black-100 text-black-800 mt-8 px-2 py-2 rounded-full font-medium">
                    <ul className="list-none lg:w-[100%] w-[100%]">
                      <li className="text-lg flex justify-between">
                        <b>Super Area </b> {floor.superArea}
                      </li>
                      <li className="text-lg flex justify-between">
                        <b>Covered Area </b> {floor.coveredArea}
                      </li>
                      <li className="text-lg flex justify-between">
                        <b>Carpet Area </b> {floor.carpetArea}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* plans section */}
      <div className="bg-black relative text-white z-50">
        <div className="w-full flex flex-col lg:flex-row justify-center">
          {/* Left Image */}
          <div className="w-full lg:w-1/2">
            <img
              src={club} // Update with actual path
              alt="Project Club View"
              loading="lazy"
              decoding="async"
              className="w-full"
            />
          </div>

          {/* Right Content */}
          <div
            className="w-full lg:w-1/2 md:p-[50px] p-[20px] flex flex-col justify-center"
            style={{
              backgroundImage: `url('${backgroundAm3}')`,
              backgroundPosition: "left center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          >
            <h2 className="capitalize  text-left text-3xl font-bold border-b border-[#cccccc42] pb-5">
              Key Project Highlights:
            </h2>
            <div className="grid grid-cols-2 gap-y-3 gap-x-10 lg:mt-16 mt-6 text-sm md:text-base">
              {/* Left Column */}
              <ul className="space-y-2 list-disc list-inside">
                {highlightsLeft.map((item, idx) => (
                  <li className="marker:text-white-500 text-[16px]" key={idx}>
                    {item}
                  </li>
                ))}
              </ul>

              {/* Right Column */}
              <ul className="space-y-2 list-disc list-inside">
                {highlightsRight.map((item, idx) => (
                  <li
                    className="marker:text-white-500 2xl:text-[16px] xl:text-[15px] lg:text-[15px] md:text-[14px]"
                    key={idx}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Last Section - Image Slider */}
      <section className="bg-[#fff] lg:py-12 py-0 px-4 relative z-50">
        <div
          ref={galleryRef}
          className="w-full mx-auto flex flex-cols flex-wrap p-4 gap-4 lg:justify-center justify-normal"
        >
          <div className="w-full lg:flex-row flex mb-7 justify-between items-center flex-col gap-2">
            <div className="flex">
              <h2 className="h2 capitalize 2xl:text-[55px] xl:text-[48px] lg:text-[46px] md:text-[40px] text-[30px]  font-bold   mb-4 leading-[120%]">
                A Flourishing Community
              </h2>
            </div>
            <p className="lg:w-1/2 w-full text-black font-normal text-[16px]">
              At Amayra Trillium, life flourishes beyond your doorstep. Discover
              lively communal areas, relaxing leisure zones, and purposefully
              crafted spaces where families bond, children thrive, and every
              moment becomes a lasting memory.
            </p>
          </div>
          <div className="2xl:w-[100%] w-[90%] text-center h-[0.5px] bg-[#00000075] mx-auto mb-2"></div>
          <div className="flex flex-col lg:gap-4 gap-2  lg:max-w-[30%] max-w-[100%] md:mt-[50px] mt-5">
            <div className="relative w-full">
              <img
                src={gallery1}
                alt="Gym"
                loading="lazy"
                decoding="async"
                className="w-full h-auto object-cover shadow-xl"
              />
            </div>
            <div className="relative w-full">
              <img
                src={gallery4}
                alt="Building"
                className="w-full h-auto object-cover shadow-xl"
              />
            </div>
            <div className="relative w-full">
              <img
                src={gallery7}
                alt="Family"
                className="w-full h-auto object-cover shadow-xl"
              />
            </div>
          </div>

          <div className="flex flex-col lg:gap-4 gap-2 lg:max-w-[30%] max-w-[100%] ">
            <div className="relative w-full">
              {" "}
              {/* Adjust the margin-top to move the middle image up */}
              <img
                src={gallery2}
                alt="Building"
                className="w-full h-auto object-cover shadow-xl"
              />
            </div>
            <div className="relative w-full">
              {" "}
              {/* Adjust the margin-top to move the middle image up */}
              <img
                src={gallery5}
                alt="Pool with float"
                className="w-full h-auto object-cover shadow-xl"
              />
            </div>
            <div className="relative w-full">
              <img
                src={gallery8}
                alt="Family"
                className="w-full h-auto object-cover shadow-xl"
              />
            </div>
          </div>

          <div className="flex flex-col lg:gap-4 gap-2 lg:max-w-[30%] max-w-[100%] md:mt-[50px] mt-1">
            <div className="relative w-full">
              <img
                src={gallery3}
                alt="Pool"
                loading="lazy"
                decoding="async"
                className="w-full h-auto object-cover shadow-xl"
              />
            </div>
            <div className="relative w-full">
              <img
                src={gallery6}
                loading="lazy"
                decoding="async"
                alt="Family"
                className="w-full h-auto object-cover shadow-xl"
              />
            </div>
            <div className="relative w-full">
              <img
                src={gallery9}
                loading="lazy"
                decoding="async"
                alt="Family"
                className="w-full h-auto object-cover shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* siteplan proof */}
      <div>
        <div className="w-full grid lg:grid-cols-2  items-center m-0">
          {/* Left -Map Image*/}
          <div className="flex justify-center items-center h-full p-0 m-0">
            <img
              src={locationMap}
              loading="lazy"
              decoding="async"
              alt="Location Map"
              className="w-max-5xl m-0 h-full"
            />
          </div>

          {/* Right -  Location Cards  */}
          <div className="grid grid-cols-1 sm:grid-cols-1 md:p-12 p-5 md:gap-2 gap-1 bg-[#521a27] h-full">
            <div
              ref={sitePlanTitleRef}
              loading="lazy"
              decoding="async"
              className="w-full flex flex-col m-0 md:pb-5 md-px-4 p-0"
            >
              <h2 className="2xl:text-[40px] xl:text-[36px] lg:text-[33px] md:text-[30px] text-[25px] text-white font-bold leading-snug md:mb-5 mb-2 capitalize">
                A New Marvel In The Vicinity Of Greater Mohali
              </h2>
            </div>
            {locations.map((item, idx) => (
              <div
                key={idx}
                ref={addToLocationCardsRef}
                className="group relative flex flex-col items-start p-0 text-white transition-shadow duration-300"
              >
                {/* Content container */}
                <div className="flex w-full relative z-10 items-center gap-4 border border-[#612831] hover:border-[#ccc] hover:rounded-2xl p-4 cursor-pointer">
                  <div className="w-10 h-10 flex items-center justify-center text-black-600 duration-300">
                    {item.icon}
                  </div>
                  <div className="flex-1">
                    <h4 className="text-white-900 text-xl font-semibold transition-colors duration-300">
                      {item.title} {item.time}
                    </h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SitePlans;
